module.exports = __webpack_public_path__ + "img/9.927d73bb.png";